{
  "id": "morning-pm",
  "label": "Morgon-pm",
  "sectionOrder": ["Inrikes", "Utrikes", "Ekonomi", "Kultur och nöje", "Sport"],
  "planning": {
    "titlePattern": "TT:s morgon-pm {dayName} den {dateRange}",
    "slugline": "TT-morgon-pm"
  },
  "sources": [
    { "type": "planning", "newsvalues": ["4", "5", "6"] },
    { "type": "event", "newsvalues": ["3", "4", "5", "6"] }
  ],
  "postamble": ["Frågor om TT:s planering besvaras av tjänstgörande nyhetschef som nås på telefon 08-692 27 00. Redaktionen nås också via mejl: redaktionen@tt.se."],
  "insertableDocuments": true,
  "insertableDocumentsFilter": { "title": "Nattens fem", "latestOnly": true },
  "insertableDocumentsBlock": "top-news",
  "blocks": [
    {
      "id": "top-news",
      "label": "Nattens fem",
      "preamble": ["God morgon! Här är nattens fem viktigaste nyheter:"],
      "grouping": "none",
      "item": {
        "headline": "{headline} – {section}",
        "lines": []
      }
    },
    {
      "id": "todays-material",
      "label": "Dagens material",
      "preamble": ["I dag kan du räkna med följande material från TT:"],
      "grouping": "section",
      "sectionHeadings": [
        { "section": "Inrikes", "heading": "Inrikes" },
        { "section": "Utrikes", "heading": "Utrikes" },
        { "section": "Ekonomi", "heading": "Ekonomi" },
        { "section": "Kultur och nöje", "heading": "Kultur och nöje" },
        { "section": "Sport", "heading": "Sport" }
      ],
      "otherSectionHeading": "Övrigt",
      "topNews": { "heading": "Toppnyheter", "types": ["planning"], "newsvalues": ["5", "6"] },
      "item": {
        "headline": "{headline}",
        "lines": ["{publicDescription}"],
        "assignmentLines": [
          { "types": ["text"], "pattern": "Text: {slugline}: {assignmentTitle}" },
          {
            "types": ["picture", "picture/video", "video"],
            "labels": {
              "picture": "Bild",
              "picture/video": "Bild/video",
              "video": "Video"
            },
            "pattern": "{assignmentLabel}: {assignmentTitle}"
          }
        ]
      },
      "eventItem": {
        "headline": "{time} - {headline} {publicDescription}",
        "lines": []
      },
      "eventTitleSections": ["Sport"],
      "eventsHeading": [
        "Presskonferenser och övrigt",
        "Nedanstående händer i dag, inget löfte om att TT bevakar:"
      ]
    }
  ]
}
